import { Modal, Tabs, Image, Tag } from '@bfe/moly';
import { CanDo } from '../CanDo';
import { HotSwap } from '../HotSwap';
import { HotTasks } from '../HotTasks';
import { useFm } from '@web3/base-hooks';
import { useState, useRef, useEffect } from 'react';
import { GUIDE_MODAL_KEY, useGuideModal } from './useGuideModal';
import { appPath } from '@web3/base-utils';
import { useRedemptionWallet } from '@/hooks/wallet';
import { scTrack } from '@web3/base-tracking';
import { Event, Page } from '@/config/track-config';

const TASKS_KEY = 'tasks';
const REWARDS_KEY = 'rewards';

export const Content = () => {
  const fm = useFm();
  const [activeKey, setActiveKey] = useState(TASKS_KEY);
  const { showGuide, setShowGuide, remainingTickets } = useGuideModal();
  const { isBybitWallet } = useRedemptionWallet();
  const tabsRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (showGuide) {
      scTrack(Event.Web3PageView, {
        page_name: Page.CheckInPopUp,
      });
    }
  }, [showGuide]);

  const RewardTab = () => {
    if (remainingTickets > 0 && isBybitWallet)
      return (
        <>
          <div className="mr-1">{fm('reward')}</div>
          <Tag variant="primary" size="normal" color="red">
            {fm('lottery')}
          </Tag>
        </>
      );

    return <div>{fm('reward')}</div>;
  };

  const items = [
    {
      key: TASKS_KEY,
      label: fm('task'),
      children: (
        <>
          <HotSwap />
          <HotTasks />
        </>
      ),
    },
    {
      key: REWARDS_KEY,
      label: <RewardTab />,
      children: <CanDo />,
    },
  ];

  const handleCheckOut = () => {
    scTrack(Event.Web3UserClick, {
      page_name: Page.CheckInPopUp,
      button_name: 'Web3Points_CheckIn',
    });

    localStorage.setItem(GUIDE_MODAL_KEY, Date.now().toString());
    setActiveKey(REWARDS_KEY);
    setShowGuide(false);

    setTimeout(() => {
      const tabsElement = tabsRef.current;
      if (tabsElement) {
        tabsElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);
  };

  return (
    <div className="main mt-12" ref={tabsRef}>
      <Tabs items={items} activeKey={activeKey} onChange={setActiveKey} />

      <Modal
        open={showGuide}
        cancelText={false}
        okText={fm('checkOut')}
        onOk={handleCheckOut}
        onClose={handleCheckOut}
        size="small"
        title={null}
      >
        <div className="flex flex-col items-center gap-6">
          <Image
            src={`${appPath}/png/home/rewards-claiming.png`}
            width={160}
            height={160}
            alt="rewards-claiming"
          />

          <div className="flex flex-col items-center gap-2 text-center">
            <p className="semi-bold-18 text-white">{fm('lotteryBonusLive')}</p>
            <p className="regular-16">
              {remainingTickets > 0 ? (
                <span
                  dangerouslySetInnerHTML={{
                    __html: fm('youHaveLotteryTickets', {
                      amount: `<span class="semi-bold-18" style="margin: 0 6px; padding: 2px 11px; border-radius: 8px; background: rgba(255, 255, 255, 0.10);">${remainingTickets}</span>`,
                    }),
                  }}
                />
              ) : (
                fm('earnPointsWinBonus')
              )}
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
};
